import script from "./CustomerColoursPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerColoursPage.vue?vue&type=script&setup=true&lang=js"

import "./CustomerColoursPage.vue?vue&type=style&index=0&id=af11ed64&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af11ed64"]])

export default __exports__